function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/**
 * Purpose: CHECKOWNNFTWHERE opcode — NFT ownership and metadata WHERE clauses.
 */

var Slip = require('./../../../../lib/saito/slip')["default"];
module.exports = {
  name: 'CHECKOWNNFTWHERE',
  description: "\nChecks that:\n1. The submitted NFT is spendable by the transaction sender (tx.from === slip2.publicKey)\n2. Additional WHERE constraints hold over NFT metadata (creator, type)\n\nRequired fields:\n  utxokey1, utxokey2, utxokey3\n",
  exampleScript: {
    op: 'CHECKOWNNFTWHERE',
    where: [{
      field: 'creator',
      operator: '==',
      value: '<publickey>'
    }, {
      field: 'type',
      operator: '==',
      value: 'stack'
    }],
    witness: {
      utxokey1: '<utxokey1>',
      utxokey2: '<utxokey2>',
      utxokey3: '<utxokey3>'
    }
  },
  execute: function execute(node, context) {
    if (!node || _typeof(node) !== 'object' || !context || _typeof(context) !== 'object') {
      return false;
    }
    var witness = node.witness;
    if (!witness || _typeof(witness) !== 'object' || Array.isArray(witness)) {
      return false;
    }
    var utxo1 = witness.utxokey1;
    var utxo2 = witness.utxokey2;
    var utxo3 = witness.utxokey3;
    if (typeof utxo1 !== 'string' || utxo1.length === 0 || typeof utxo2 !== 'string' || utxo2.length === 0 || typeof utxo3 !== 'string' || utxo3.length === 0) {
      return false;
    }
    var slip1 = Slip.fromUtxoKey(utxo1);
    var slip2 = Slip.fromUtxoKey(utxo2);
    var slip3 = Slip.fromUtxoKey(utxo3);
    if (!slip1 || !slip2 || !slip3) {
      return false;
    }
    if (!context.__opcodes) {
      context.__opcodes = {};
    }
    context.__opcodes.checkownnftwhere = {
      nft_id: utxo3.substring(0, 66).toLowerCase()
    };
    var tx = context.tx;
    if (tx && Array.isArray(tx.from) && tx.from.length > 0) {
      var sender = tx.from[0].publicKey;
      if (sender !== slip2.publicKey) {
        return false;
      }
    }
    var nft_type = context.app && context.app.wallet && typeof context.app.wallet.extractNFTType === 'function' ? context.app.wallet.extractNFTType(utxo3) : null;
    var creator = slip1.publicKey;
    if (Array.isArray(node.where)) {
      for (var i = 0; i < node.where.length; i += 1) {
        var clause = node.where[i];
        if (!clause || _typeof(clause) !== 'object') {
          return false;
        }
        var lhs = void 0;
        if (clause.field === 'creator') {
          lhs = creator;
        } else if (clause.field === 'type') {
          lhs = nft_type;
        } else {
          return false;
        }
        var rhs = clause.value;
        if (clause.operator === '==') {
          if (lhs !== rhs) {
            return false;
          }
        } else if (clause.operator === '!=') {
          if (lhs === rhs) {
            return false;
          }
        } else {
          return false;
        }
      }
    }
    return true;
  }
};